/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

export const RETRIEVE_OTP_RESET_PASSWORD = `/v2/password/request`;
export const RETRIEVE_RESET_PASSWORD = `/v2/reset-password`;

export type retrieveResetPasswordOTPBody = {
  email: string;
};

export type retrieveResetPasswordOTPResponse = {
  data: {
    code: number;
    token: string;
    type: number;
    validTo: number;
  };
};

export const retrieveResetPasswordOTP = ({
  email,
}: retrieveResetPasswordOTPBody) =>
  httpClient.post<retrieveResetPasswordOTPResponse>(
    RETRIEVE_OTP_RESET_PASSWORD,
    {
      email,
    },
  );

export const useRetrieveResetPasswordOTP = (
  opts?: UseMutationOptions<
    AxiosResponse<retrieveResetPasswordOTPResponse>,
    AxiosError<any>,
    retrieveResetPasswordOTPBody
  >,
) =>
  useMutation<
    AxiosResponse<retrieveResetPasswordOTPResponse>,
    AxiosError<any>,
    retrieveResetPasswordOTPBody
  >(retrieveResetPasswordOTP, opts);

export type retrieveResetPasswordBody = {
  token: string;
  password: string;
};

export type retrieveResetPasswordResponse = {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
};

export const retrieveResetPassword = ({
  token,
  password,
}: retrieveResetPasswordBody) =>
  httpClient.put<retrieveResetPasswordResponse>(RETRIEVE_RESET_PASSWORD, {
    token,
    password,
  });

export const useRetrieveResetPassword = (
  opts?: UseMutationOptions<
    AxiosResponse<retrieveResetPasswordResponse>,
    AxiosError<any>,
    retrieveResetPasswordBody
  >,
) =>
  useMutation<
    AxiosResponse<retrieveResetPasswordResponse>,
    AxiosError<any>,
    retrieveResetPasswordBody
  >(retrieveResetPassword, opts);

const OTP_STUDENT = `/v2/otp`;

export type RetrieveOTPBodyResp = {
  token: string;
  code?: number | string;
};

export type RetrieveOTPResponse = any;

export const retrieveOTP = ({ token, code }: RetrieveOTPBodyResp) =>
  httpClient.post<RetrieveOTPResponse>(OTP_STUDENT, {
    token,
    code,
  });

export const useRetrieveOTP = (
  opts?: UseMutationOptions<
    AxiosResponse<RetrieveOTPResponse>,
    AxiosError<any>,
    RetrieveOTPBodyResp
  >,
) =>
  useMutation<
    AxiosResponse<RetrieveOTPResponse>,
    AxiosError<any>,
    RetrieveOTPBodyResp
  >(retrieveOTP, opts);

export type retrieveResendOTPBody = {
  token: string;
};

export type retrieveResendOTPResponse = any;

export const retrieveResendOTP = ({ token }: retrieveResendOTPBody) =>
  httpClient.put<retrieveResendOTPResponse>(OTP_STUDENT, {
    token,
  });

export const useRetrieveResendOTP = (
  opts?: UseMutationOptions<
    AxiosResponse<retrieveResendOTPResponse>,
    AxiosError<any>,
    retrieveResendOTPBody
  >,
) =>
  useMutation<
    AxiosResponse<retrieveResendOTPResponse>,
    AxiosError<any>,
    retrieveResendOTPBody
  >(retrieveResendOTP, opts);
